import React from 'react'

const ErrorHeader = () => {
  return (
    <div>ErrorHeader</div>
  )
}

export default ErrorHeader